import { NgClass, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-header-contact-us-section',
  templateUrl: './header-contact-us-section.component.html',
  styleUrls: ['./header-contact-us-section.component.scss'],
  standalone: true,
  imports:[NgClass,NgIf]
})
export class HeaderContactUsSectionComponent {
  commonImagePath: string = environment.commonImagePath;
  chTheme6 = environment.chTheme6;
  chTheme9 = environment.chTheme9;
  phoneImg=environment.phoneImg;
  contact: string = environment.contact_no;
  formatted_contact: string = this.contact.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");

  constructor(private dynamicThemeClassService: DynamicThemeClassService) {}
  
    themeClass(divName: string): string {
      return this.dynamicThemeClassService.generateClassName(divName);
    }
}
